import styled from "styled-components";

export const ApplicantLayoutStyle = styled.div`
    width: 1000px;
    .common-tabs {
        padding: 0;
    }
`